<!--  -->
<template>
    <div class='platformRow'>
        <div class='content'>
            <div class="title">平台优势</div>
            <div class="subtitle">无需安装，功能全面，安全保障，云上应用</div>
            <div class="platformContent box" @touchstart="hanleTouchStart" @touchmove="hanleTouchMove" @touchend="hanleTouchEnd" ref="slideContent">
                <div class="platformItem" v-for="(item,index) in datalist" :key="index" :class="{right:isPhone && index%2}">
                    <img class="platformImg" :src="item.bgc"/>
                    <div class="platformTitle">{{item.title}}</div>
                    <div class="platformSubTitle" v-html="item.content"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
let  x0,x1,xw=0 //x0手指开始位置  x1手指结束位置  xw手指位移
let now_page=0//开始元素
let length = 4;
export default {
    props:['isPhone'],
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            datalist:[{
                bgc:require('../../../assets/images/showProduct/platform1.png'),
                title:'连接微信',
                content:'无需安装<br/>打开微信即可<br/>操作简单无需培训'
            },{
                bgc:require('../../../assets/images/showProduct/platform2.png'),
                title:'功能全面',
                content:'连接社区、公服企业<br/>周边商家和社区居民<br/>全面解决基层治理难题'
            },{
                bgc:require('../../../assets/images/showProduct/platform3.png'),
                title:'安全保障',
                content:'银行级加密传输<br/>多层数据安全保护机制<br/>容灾备份抵御网络攻击'
            },{
                bgc:require('../../../assets/images/showProduct/platform4.png'),
                title:'云上应用',
                content:'注册即可使用<br/>功能持续升级<br/>免部署，免维护'
            }]
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        hanleTouchStart(e){
            console.log('touchstart')
            console.log(e)
            x0=e.touches[0].clientX;
        },
        hanleTouchMove(e){
            console.log('touchmove')
             x1=e.changedTouches[0].clientX;
             xw=x1-x0;
        },
        hanleTouchEnd(e){
            console.log('touchend')
             if(xw>0){
                    //右滑
                    this.slideContentRight()
                    xw = 0

                }else if(xw<0){
                    //左滑
                    this.slideContentLeft()
                    xw = 0

                }else if(xw==0){
                    //点击事件
                    //alert(now_page)
                }
        },
        slideContentLeft(){
            //左滑
               if(now_page<length-1){
                   console.log('nowpage:'+now_page)
                   console.log('nowpage:'+(9+now_page*15))
                    this.$refs.slideContent.style.marginLeft = "-"+(9+now_page*15)+"rem";
                    now_page++;
               }

        },
        slideContentRight(){
              //右滑
               now_page--;
                if(now_page>0){
                    this.$refs.slideContent.style.marginLeft = "-"+((now_page-1)*15+9)+"rem";

               }else if(now_page == 0){
                    this.$refs.slideContent.style.marginLeft = "6rem";
               }

        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>

<style src="../pc.css" scoped></style>
<style src="../phone.css" scoped></style>


